import React, { Component } from 'react';
import { appendAttachment } from '../../../utils/FormDataUtils';
import '../../../resources/AdminStandardPage.css';
import AuthenticationService from '../../../services/AuthenticationService';
import DeletePUGCertificates from '../../../components/Dialogs/DeleteDialog/DeleteDialog';
import InputLabel from '@material-ui/core/InputLabel';
import AttachmentField from '../../../components/AttachmentField/AttachmentField';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import NotificationSystem from 'react-notification-system';
import NotificationSystemStyle from '../../../constants/NotificationSystemStyle';
import { submittedProjectsService } from '../../../services/SubmittedProjectsService';
import ReactPaginate from 'react-paginate';

class SubmittedProjectsAdmin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      disabledDocument: false,
      newSubmittedProject: {
        title: '',
        description: '',
        value: '',
        stage: '',
        document: ''
      },
      existingProjects: [],
      deleteProject: {
        openedDialog: false,
        deleteId: 0
      }
    };

    this.authentication = new AuthenticationService();
  }

  componentWillMount() {
    submittedProjectsService
      .getAll()
      .then(jsonResponse => {
        this.setSubmittedProjectsState(jsonResponse);
      })
      .catch(error => console.log(error));
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  handlePageClick = selectedPage => {
    submittedProjectsService
      .getAll(selectedPage.selected + 1)
      .then(jsonResponse => {
        this.setSubmittedProjectsState(jsonResponse);
      })
      .catch(error => console.log(error));
  };

  setSubmittedProjectsState = response => {
    let existingProjects = { ...this.state.existingProjects };
    let pagination = { ...this.state.pagination };
    existingProjects = response.submitted_projects;
    pagination = response.pagination;

    this.setState({ existingProjects });
    this.setState({ pagination });
  };

  updateField = event => {
    const field = event.target.name;
    const newSubmittedProject = this.state.newSubmittedProject;
    newSubmittedProject[field] = event.target.value;

    this.setState({
      newSubmittedProject
    });
  };

  onDropDocument = documents => {
    let newSubmittedProject = { ...this.state.newSubmittedProject };
    let reader = new FileReader();
    let self = this;

    reader.onload = function(upload) {
      newSubmittedProject.document = documents[0];

      self.setState({ newSubmittedProject });
      self.setState({ disabledDocument: true });
    };
    reader.readAsDataURL(documents[0]);
  };

  removeDocument = () => {
    let newSubmittedProject = { ...this.state.newSubmittedProject };
    newSubmittedProject.document = null;

    this.setState({ newSubmittedProject });
    this.setState({ disabledDocument: false });
  };

  resetForm = () => {
    let newSubmittedProject = { ...this.state.newSubmittedProject };
    newSubmittedProject = {
      title: '',
      description: '',
      value: '',
      stage: '',
      document: ''
    };

    this.setState({ newSubmittedProject });
    this.setState({ disabledDocument: false });
  };

  handleFormSubmit = event => {
    event.preventDefault();
    const currentId = this.state.newSubmittedProject.id;

    const headers = {
      Accept: 'application/json'
    };

    if (this.authentication.loggedIn()) {
      headers['Authorization'] = 'Bearer ' + this.authentication.getToken();
    }

    let url = `${process.env.REACT_APP_API_URL}/api/submitted_projects/`;
    let callMethod = 'POST';

    if (currentId) {
      url = `${process.env.REACT_APP_API_URL}/api/submitted_projects/${this.state.newSubmittedProject.id}`;
      callMethod = 'PUT';
    }

    const formattedData = this.buildFormData();

    fetch(url, {
      method: callMethod,
      body: formattedData,
      headers
    })
      .then(this.handleErrors)
      .then(response => response.json())
      .then(jsonResponse => {
        this.resetForm();

        let existingProjects = this.state.existingProjects.slice();

        let index = existingProjects.findIndex(
          existingProject => existingProject.id === jsonResponse.id
        );

        if (index !== -1) {
          existingProjects[index] = jsonResponse;
        } else {
          existingProjects.push(jsonResponse);
        }

        this.setState({ existingProjects });

        if (currentId) {
          this._notificationSystem.addNotification({
            message: 'Proiectul a fost editat cu success.',
            level: 'success',
            position: 'tc'
          });
        } else {
          this._notificationSystem.addNotification({
            message: 'Proiectul a fost adaugat cu success.',
            level: 'success',
            position: 'tc'
          });
        }
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  buildFormData() {
    let formData = new FormData();
    formData.append(
      'submitted_project[title]',
      this.state.newSubmittedProject.title
    );
    formData.append(
      'submitted_project[description]',
      this.state.newSubmittedProject.description
    );
    formData.append(
      'submitted_project[value]',
      this.state.newSubmittedProject.value
    );
    formData.append(
      'submitted_project[stage]',
      this.state.newSubmittedProject.stage
    );

    if (this.state.newSubmittedProject.document) {
      let document = this.state.newSubmittedProject.document;
      appendAttachment(formData, `submitted_project[document]`, document);
    }

    return formData;
  }

  setCertificateForEdit = newProject => {
    let newSubmittedProject = { ...this.state.newSubmittedProject };
    newSubmittedProject = Object.assign({}, newProject);
    this.setState({ newSubmittedProject });

    if (newSubmittedProject.document.url) {
      this.setState({ disabledDocument: true });
    }
  };

  openDeleteDialog = id => {
    let deleteProject = { ...this.state.deleteProject };
    deleteProject = {
      openedDialog: true,
      deleteId: id
    };

    this.setState({ deleteProject });
  };

  closeDeleteDialog = () => {
    let deleteProject = { ...this.state.deleteProject };
    deleteProject = {
      openedDialog: false,
      deleteId: 0
    };

    this.setState({ deleteProject });
  };

  handleDelete = () => {
    submittedProjectsService
      .deleteSubmittedProject(this.state.deleteProject.deleteId)
      .then(() => {
        let existingProjects = this.state.existingProjects.slice();
        existingProjects = existingProjects.filter(
          project => project.id !== this.state.deleteProject.deleteId
        );
        this.setState({ existingProjects });

        this.closeDeleteDialog();

        this._notificationSystem.addNotification({
          message: 'Proiectul a fost stears cu success.',
          level: 'success',
          position: 'tc'
        });
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  handleErrors = response => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  };

  render() {
    return (
      <div className="admin-standard-page">
        <div className="admin-standard-page__title">
          <h3 className="admin-page__profile-title profile-title-specific">
            Interes Public
          </h3>
          <h1 className="admin-switch-title default-title">
            Proiecte in desfasurare
          </h1>
        </div>
        <div className="title-line" />
        <div className="admin-standard-page__content">
          <div className="admin-standard-page__create-project">
            <div className="card">
              <form className="admin-form" onSubmit={this.handleFormSubmit}>
                <h2 className="admin-form__title">Adauga un proiect depus</h2>

                <div className="admin-form__field">
                  <h4 className="label-title label-title-provisions">
                    Titlu proiect*
                  </h4>
                  <input
                    required
                    className="general-field title-field"
                    type="text"
                    name="title"
                    onChange={this.updateField}
                    value={this.state.newSubmittedProject.title}
                  />

                  <h4 className="label-title label-title-provisions">
                    Descriere proiect*
                  </h4>
                  <textarea
                    required
                    cols="5"
                    className="general-field title-field"
                    type="text"
                    name="description"
                    onChange={this.updateField}
                    value={this.state.newSubmittedProject.description}
                  />

                  <h4 className="label-title label-title-provisions">
                    Valoare proiect (valoarea este reprezentata in RON)*
                  </h4>
                  <input
                    required
                    className="general-field title-field"
                    type="number"
                    name="value"
                    onChange={this.updateField}
                    value={this.state.newSubmittedProject.value}
                  />
                </div>
                <div className="admin-form__upload">
                  <h4 className="label-title label-title-provisions">
                    Document proiect:
                  </h4>
                  <AttachmentField
                    onDrop={this.onDropDocument}
                    removeDocument={this.removeDocument}
                    disabledDocuments={this.state.disabledDocument}
                    document={this.state.newSubmittedProject.document}
                    documentFilename={
                      this.state.newSubmittedProject.document_filename
                    }
                    type="application/pdf"
                  />
                </div>
                <div className="admin-form__field">
                  <FormControl className="admin-form__field-select">
                    <InputLabel htmlFor="stage-native">
                      Stagiu Proiect
                    </InputLabel>
                    <Select
                      native
                      required
                      onChange={this.updateField}
                      value={this.state.newSubmittedProject.stage}
                      inputProps={{
                        id: 'stage-native',
                        name: 'stage'
                      }}
                    >
                      <option value="" />
                      <option value="asteptare">In Asteptare</option>
                      <option value="aprobat">Aprobat</option>
                      <option value="respins">Respins</option>
                    </Select>
                  </FormControl>
                </div>
                <div className="form-buttons">
                  <div className="admin-form__submit">
                    <button
                      type="submit"
                      className="submit-button general-button"
                    >
                      {this.state.newSubmittedProject.id
                        ? 'Editează Proiect'
                        : 'Adaugă Proiect'}
                    </button>
                  </div>
                  {Object.values(this.state.newSubmittedProject) && (
                    <button
                      type="button"
                      className="general-button reset-button"
                      onClick={() => this.resetForm()}
                    >
                      Resetează câmpurile
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
          {this.state.existingProjects.length > 0 && (
            <div className="admin-standard-page__existing-items">
              <div className="card">
                <div className="existing-items">
                  <h2 className="existing-items__title label-title">
                    Proiecte depuse existente
                  </h2>
                  <div className="existing-items__content">
                    {this.state.existingProjects.map(project => (
                      <div
                        className="existing-items__content-card"
                        key={project.id}
                      >
                        <div className="card-content provisions-title-content">
                          <h3 className="major-provisions-title">
                            {project.title}
                          </h3>
                        </div>
                        <div className="existing-items__actions-card">
                          <div
                            className="provisions-title-content"
                            onClick={() => this.setCertificateForEdit(project)}
                          >
                            <h4 className="action-title"> Editează</h4>
                          </div>

                          <div
                            className="provisions-title-content"
                            onClick={() => this.openDeleteDialog(project.id)}
                          >
                            <h4 className="action-title delete-button">
                              {' '}
                              Șterge
                            </h4>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <DeletePUGCertificates
                    opened={this.state.deleteProject.openedDialog}
                    handleClose={this.closeDeleteDialog}
                    handleDelete={this.handleDelete}
                    headline="Sunteti sigur ca doriti sa stergeti acest proiect?"
                    aditionalText="Dupa stergere, proiectul nu va mai putea fi recuperat."
                  />
                </div>
                {this.state.pagination.last_page > 1 && (
                  <ReactPaginate
                    previousLabel={'<'}
                    nextLabel={'>'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={this.state.pagination.last_page}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={2}
                    onPageChange={this.handlePageClick}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                  />
                )}
              </div>
            </div>
          )}
        </div>
        <NotificationSystem
          ref="notificationSystem"
          style={NotificationSystemStyle}
        />
      </div>
    );
  }
}

export default SubmittedProjectsAdmin;
